// src/services/performance.js - Version corrigée pour l'ordre des niveaux
// Données des minima officiels de la Fédération Française d'Haltérophilie-Musculation
// Source: https://halterophiliefrance.fr/minima-halterophilie/

// Définition des niveaux et de leur nom d'affichage
const niveaux = [
  {
    id: "intA",
    nom: "International A",
    index: 0,
    color: "deep-orange-accent-3",
  },
  { id: "intB", nom: "International B", index: 1, color: "amber-darken-2" },
  { id: "nat", nom: "National", index: 2, color: "deep-purple-darken-1" },
  { id: "fed", nom: "Fédéral", index: 3, color: "indigo-darken-1" },
  { id: "irg", nom: "Interrégional", index: 4, color: "blue-darken-1" },
  { id: "reg", nom: "Régional", index: 5, color: "teal-darken-1" },
  { id: "dpt", nom: "Départemental", index: 6, color: "green-darken-1" },
  { id: "deb", nom: "Débutant", index: 7, color: "grey-darken-1" },
];

// Minima Hommes U15 (Format: [DEB, DPT, REG, IRG, FED, NAT, INT B, INT A])
const minimaHommesU15 = {
  "49 kg": [40, 55, 70, 85, 100, 115, 135, 155],
  "55 kg": [55, 70, 85, 100, 115, 130, 150, 170],
  "61 kg": [65, 80, 100, 115, 130, 150, 170, 190],
  "67 kg": [75, 95, 110, 130, 150, 170, 190, 210],
  "73 kg": [80, 100, 120, 140, 160, 180, 200, 220],
  "81 kg": [85, 105, 130, 150, 170, 190, 210, 230],
  "89 kg": [90, 110, 135, 155, 175, 200, 220, 240],
  "96 kg": [95, 115, 140, 160, 180, 205, 225, 250],
  "102 kg": [100, 120, 145, 165, 185, 210, 230, 255],
  ">102 kg": [105, 125, 150, 170, 190, 215, 235, 260],
};

// Minima Hommes U17 (Format: [DEB, DPT, REG, IRG, FED, NAT, INT B, INT A])
const minimaHommesU17 = {
  "49 kg": [50, 65, 80, 95, 110, 125, 145, 165],
  "55 kg": [65, 85, 100, 115, 130, 145, 175, 195],
  "61 kg": [80, 100, 120, 135, 150, 170, 195, 215],
  "67 kg": [90, 110, 130, 150, 170, 190, 215, 235],
  "73 kg": [100, 120, 140, 160, 180, 200, 225, 250],
  "81 kg": [110, 130, 150, 170, 190, 210, 235, 265],
  "89 kg": [115, 135, 160, 180, 200, 220, 245, 275],
  "96 kg": [120, 140, 165, 185, 205, 225, 255, 285],
  "102 kg": [125, 145, 170, 190, 210, 230, 260, 290],
  ">102 kg": [130, 150, 175, 195, 215, 235, 265, 300],
};

// Minima Hommes U20 (Format: [DEB, DPT, REG, IRG, FED, NAT, INT B, INT A])
const minimaHommesU20 = {
  "55 kg": [80, 100, 115, 130, 145, 170, 195, 225],
  "61 kg": [95, 115, 130, 150, 170, 190, 220, 245],
  "67 kg": [105, 125, 150, 170, 190, 218, 245, 265],
  "73 kg": [120, 140, 160, 180, 200, 230, 260, 285],
  "81 kg": [130, 150, 170, 190, 215, 245, 275, 305],
  "89 kg": [135, 160, 180, 200, 225, 255, 290, 315],
  "96 kg": [140, 165, 185, 210, 230, 260, 295, 325],
  "102 kg": [145, 170, 190, 215, 240, 270, 305, 335],
  "109 kg": [150, 175, 195, 220, 245, 275, 315, 345],
  ">109 kg": [155, 180, 200, 225, 250, 280, 320, 355],
};

// Minima Hommes Seniors (Format: [DEB, DPT, REG, IRG, FED, NAT, INT B, INT A])
const minimaHommesSeniors = {
  "55 kg": [95, 115, 130, 145, 170, 190, 220, 240],
  "61 kg": [110, 130, 150, 170, 195, 215, 245, 270],
  "67 kg": [125, 145, 170, 195, 225, 240, 270, 295],
  "73 kg": [135, 160, 185, 210, 240, 260, 290, 315],
  "81 kg": [145, 170, 195, 220, 250, 275, 305, 335],
  "89 kg": [150, 175, 200, 230, 260, 287, 320, 350],
  "96 kg": [155, 180, 205, 235, 265, 295, 330, 360],
  "102 kg": [160, 185, 210, 240, 270, 302, 340, 370],
  "109 kg": [165, 190, 215, 245, 275, 310, 350, 380],
  ">109 kg": [170, 195, 220, 250, 280, 315, 355, 395],
};

// Minima Hommes Masters M35-M39 (Format: [REGION, FRANCE, EUROPE, MONDE])
const minimaHommesM35 = {
  "55 kg": [115, 140, 153, 160],
  "61 kg": [132, 155, 165, 178],
  "67 kg": [147, 170, 176, 194],
  "73 kg": [160, 182, 186, 206],
  "81 kg": [170, 192, 197, 218],
  "89 kg": [180, 202, 207, 228],
  "96 kg": [185, 210, 214, 235],
  "102 kg": [190, 214, 219, 240],
  "109 kg": [195, 218, 224, 246],
  ">109 kg": [200, 222, 231, 252],
};

// Minima Femmes U15 (Format: [DEB, DPT, REG, IRG, FED, NAT, INT B, INT A])
const minimaFemmesU15 = {
  "40 kg": [20, 25, 35, 45, 57, 72, 85, 100],
  "45 kg": [25, 35, 45, 55, 67, 82, 95, 110],
  "49 kg": [30, 40, 50, 62, 75, 90, 105, 120],
  "55 kg": [35, 45, 57, 70, 85, 100, 115, 130],
  "59 kg": [40, 50, 62, 75, 90, 105, 120, 140],
  "64 kg": [45, 55, 67, 80, 95, 110, 125, 145],
  "71 kg": [50, 60, 72, 85, 100, 115, 130, 150],
  "76 kg": [55, 65, 75, 87, 105, 120, 132, 152],
  "81 kg": [57, 67, 77, 90, 107, 122, 135, 153],
  ">81 kg": [60, 70, 80, 95, 110, 125, 140, 155],
};

// Minima Femmes U17 (Format: [DEB, DPT, REG, IRG, FED, NAT, INT B, INT A])
const minimaFemmesU17 = {
  "40 kg": [30, 35, 45, 58, 70, 82, 95, 110],
  "45 kg": [35, 42, 50, 63, 78, 90, 105, 120],
  "49 kg": [40, 50, 57, 70, 87, 100, 115, 130],
  "55 kg": [45, 55, 65, 80, 97, 110, 125, 140],
  "59 kg": [50, 60, 70, 82, 102, 115, 130, 150],
  "64 kg": [55, 65, 75, 87, 105, 120, 135, 160],
  "71 kg": [60, 70, 80, 92, 110, 125, 140, 165],
  "76 kg": [65, 75, 85, 97, 115, 130, 142, 170],
  "81 kg": [67, 77, 90, 100, 117, 135, 150, 171],
  ">81 kg": [70, 80, 95, 105, 120, 140, 155, 172],
};

// Minima Femmes U20 (Format: [DEB, DPT, REG, IRG, FED, NAT, INT B, INT A])
const minimaFemmesU20 = {
  "45 kg": [40, 50, 60, 72, 85, 100, 117, 140],
  "49 kg": [45, 55, 65, 80, 95, 110, 127, 150],
  "55 kg": [50, 62, 75, 90, 108, 122, 145, 165],
  "59 kg": [55, 70, 82, 97, 115, 130, 152, 180],
  "64 kg": [60, 75, 90, 105, 122, 140, 160, 185],
  "71 kg": [65, 80, 95, 110, 125, 145, 167, 190],
  "76 kg": [70, 85, 100, 115, 130, 150, 172, 195],
  "81 kg": [75, 90, 105, 120, 135, 155, 175, 198],
  "87 kg": [77, 92, 107, 122, 140, 160, 180, 200],
  ">87 kg": [80, 95, 110, 125, 145, 165, 185, 205],
};

// Minima Femmes Seniors (Format: [DEB, DPT, REG, IRG, FED, NAT, INT B, INT A])
const minimaFemmesSeniors = {
  "45 kg": [50, 60, 70, 85, 102, 117, 135, 150],
  "49 kg": [55, 67, 80, 95, 115, 130, 150, 170],
  "55 kg": [60, 75, 87, 105, 130, 145, 165, 185],
  "59 kg": [65, 80, 92, 112, 140, 155, 175, 200],
  "64 kg": [70, 85, 100, 122, 147, 165, 185, 208],
  "71 kg": [75, 90, 107, 130, 152, 172, 192, 212],
  "76 kg": [80, 95, 115, 135, 155, 176, 196, 216],
  "81 kg": [85, 100, 120, 137, 157, 180, 200, 220],
  "87 kg": [87, 102, 122, 140, 160, 182, 202, 224],
  ">87 kg": [90, 105, 125, 142, 162, 185, 205, 228],
};

// Minima Femmes Masters W35-W39 (Format: [REGION, FRANCE, EUROPE, MONDE])
const minimaFemmesW35 = {
  "45 kg": [50, 65, 79, 90],
  "49 kg": [55, 72, 85, 99],
  "55 kg": [60, 80, 93, 110],
  "59 kg": [65, 85, 98, 117],
  "64 kg": [70, 90, 104, 123],
  "71 kg": [74, 94, 111, 130],
  "76 kg": [77, 97, 115, 135],
  "81 kg": [80, 100, 119, 139],
  "87 kg": [85, 105, 123, 143],
  ">87 kg": [90, 110, 126, 150],
};

/**
 * Détermine la catégorie d'âge d'un athlète
 */
export const getAgeCategory = (age) => {
  if (age < 15) return "U15";
  if (age < 17) return "U17";
  if (age < 20) return "U20";
  if (age < 35) return "Senior";
  return "Master";
};

/**
 * Détermine la catégorie de poids d'un athlète
 */
export const getWeightCategory = (gender, bodyWeight, ageCategory) => {
  let categories;
  let values;

  if (gender === "M") {
    if (ageCategory === "U15" || ageCategory === "U17") {
      categories = [
        "49 kg",
        "55 kg",
        "61 kg",
        "67 kg",
        "73 kg",
        "81 kg",
        "89 kg",
        "96 kg",
        "102 kg",
        ">102 kg",
      ];
      values = [49, 55, 61, 67, 73, 81, 89, 96, 102];
    } else {
      categories = [
        "55 kg",
        "61 kg",
        "67 kg",
        "73 kg",
        "81 kg",
        "89 kg",
        "96 kg",
        "102 kg",
        "109 kg",
        ">109 kg",
      ];
      values = [55, 61, 67, 73, 81, 89, 96, 102, 109];
    }
  } else {
    if (ageCategory === "U15" || ageCategory === "U17") {
      categories = [
        "40 kg",
        "45 kg",
        "49 kg",
        "55 kg",
        "59 kg",
        "64 kg",
        "71 kg",
        "76 kg",
        "81 kg",
        ">81 kg",
      ];
      values = [40, 45, 49, 55, 59, 64, 71, 76, 81];
    } else {
      categories = [
        "45 kg",
        "49 kg",
        "55 kg",
        "59 kg",
        "64 kg",
        "71 kg",
        "76 kg",
        "81 kg",
        "87 kg",
        ">87 kg",
      ];
      values = [45, 49, 55, 59, 64, 71, 76, 81, 87];
    }
  }

  for (let i = 0; i < values.length; i++) {
    if (bodyWeight <= values[i]) {
      return categories[i];
    }
  }

  return categories[categories.length - 1]; // Catégorie poids lourd
};

/**
 * Obtient les minima pour une catégorie spécifique
 */
const getMinima = (gender, ageCategory, weightCategory) => {
  if (gender === "M") {
    if (ageCategory === "U15") return minimaHommesU15[weightCategory];
    if (ageCategory === "U17") return minimaHommesU17[weightCategory];
    if (ageCategory === "U20") return minimaHommesU20[weightCategory];
    if (ageCategory === "Senior") return minimaHommesSeniors[weightCategory];
    if (ageCategory === "Master") {
      // Pour simplifier, nous utilisons seulement M35-M39 pour les masters
      return minimaHommesM35[weightCategory];
    }
  } else {
    if (ageCategory === "U15") return minimaFemmesU15[weightCategory];
    if (ageCategory === "U17") return minimaFemmesU17[weightCategory];
    if (ageCategory === "U20") return minimaFemmesU20[weightCategory];
    if (ageCategory === "Senior") return minimaFemmesSeniors[weightCategory];
    if (ageCategory === "Master") {
      // Pour simplifier, nous utilisons seulement W35-W39 pour les masters
      return minimaFemmesW35[weightCategory];
    }
  }
  return null;
};

/**
 * Évalue le niveau d'un athlète en fonction de ses performances
 */
export const evaluatePerformance = (
  age,
  gender,
  snatch,
  cleanAndJerk,
  bodyWeight,
) => {
  // Calculer le total
  const total = snatch + cleanAndJerk;

  // Déterminer la catégorie d'âge
  const ageCategory = getAgeCategory(age);

  // Déterminer la catégorie de poids
  const weightCategory = getWeightCategory(gender, bodyWeight, ageCategory);

  // Minima pour cette catégorie
  const minima = getMinima(gender, ageCategory, weightCategory);

  // Si minima non trouvés, retourner une évaluation par défaut
  if (!minima) {
    return {
      total,
      ageCategory,
      weightCategory,
      gender,
      levelId: "unknown",
      levelName: "Non classé",
      levelColor: "grey-darken-3",
      message: "Catégorie non disponible",
    };
  }

  // Créer une copie des minima pour le traitement
  let thresholds = [...minima];

  // Inverser l'ordre des minima si nécessaire - les minima sont actuellement du plus bas au plus élevé
  // et nous voulons les mettre du plus élevé au plus bas
  const reversedThresholds = thresholds.slice().reverse();

  // Pour les masters, adapter le format des données
  let allLevels = [];
  let levelReached = null;

  if (ageCategory === "Master") {
    // Format masters: [REGION, FRANCE, EUROPE, MONDE]
    const masterLevels = [
      {
        id: "monde",
        nom: "Niveau Monde",
        seuil: minima[3],
        atteint: total >= minima[3],
        color: "deep-orange-accent-3",
      },
      {
        id: "europe",
        nom: "Niveau Europe",
        seuil: minima[2],
        atteint: total >= minima[2],
        color: "amber-darken-2",
      },
      {
        id: "france",
        nom: "Niveau France",
        seuil: minima[1],
        atteint: total >= minima[1],
        color: "deep-purple-darken-1",
      },
      {
        id: "region",
        nom: "Niveau Région",
        seuil: minima[0],
        atteint: total >= minima[0],
        color: "blue-darken-1",
      },
    ];

    // Trouver le niveau le plus élevé atteint
    for (const level of masterLevels) {
      if (level.atteint) {
        levelReached = level;
        break; // On s'arrête au premier niveau atteint (le plus élevé)
      }
    }

    allLevels = masterLevels;
  } else {
    // Pour les catégories standard, nous utilisons les seuils inversés (du plus élevé au plus bas)
    const standardLevels = reversedThresholds.map((threshold, idx) => ({
      id: niveaux[idx].id,
      nom: niveaux[idx].nom,
      seuil: threshold,
      atteint: total >= threshold,
      color: niveaux[idx].color,
    }));

    // Trouver le niveau le plus élevé atteint
    for (const level of standardLevels) {
      if (level.atteint) {
        levelReached = level;
        break; // On s'arrête au premier niveau atteint (le plus élevé)
      }
    }

    allLevels = standardLevels;
  }

  // Si aucun niveau n'est atteint, on considère le niveau "Débutant"
  if (!levelReached) {
    levelReached = {
      id: "deb",
      nom: "Débutant",
      seuil: 0,
      atteint: true,
      color: "grey-darken-1",
    };

    // Ajouter le niveau débutant s'il n'existe pas déjà
    if (!allLevels.find((l) => l.id === "deb")) {
      allLevels.push(levelReached);
    }
  }

  // Trier les niveaux pour l'affichage (du plus élevé au plus bas)
  allLevels.sort((a, b) => b.seuil - a.seuil);

  // Trouver le prochain niveau à atteindre
  const currentLevelIndex = allLevels.findIndex(
    (l) => l.id === levelReached.id,
  );
  const nextLevel =
    currentLevelIndex > 0 ? allLevels[currentLevelIndex - 1] : null;

  return {
    total,
    ageCategory,
    weightCategory,
    gender,
    levelId: levelReached.id,
    levelName: levelReached.nom,
    levelColor: levelReached.color,
    allLevels,
    nextLevel,
  };
};

/**
 * Retourne la liste de tous les niveaux possibles
 */
export const getAllLevels = () => niveaux;
